import Index from '@/page/byl/index'
import Home from '@/page/byl/home'
import Characteristic from '@/page/byl/characteristic'
import Training from '@/page/byl/training'
import Web_education from '@/page/byl/web_education'
// import PageLogin from '@/page/byl/auth/login-page'
import PageLogin from '@/connects/pageLogin'
import PageOrgReg from '@/page/byl/auth/org-reg-page'
import PageFindPwd from '@/page/byl/auth/find-pwd-page'
import PageResetPwd from '@/page/byl/auth/reset-pwd-page'

import PageOrg from '@/page/byl/org/index'
import PageOrgStructure from '@/page/byl/org/structure/index'
import PageOrgReports from '@/page/byl/org/reports/index'
import PageOrgExternals from '@/page/byl/org/externals/index'
import PageOrgGroup from '@/page/byl/org/group/index'
import PageOrgTag from '@/page/byl/org/tag/model'
import PageOrgTagList from '@/page/byl/org/tag/list'
import PageOrgMsg from '@/page/byl/org/msg/model'
import PageOrgMsgList from '@/page/byl/org/msg/list'
import PageOrgResource from '@/page/byl/org/resource/model'
import PageOrgResourceList from '@/page/byl/org/resource/list'
import PageOrgRepo from '@/page/byl/org/repo/model'
import PageOrgRepoList from '@/page/byl/org/repo/list'
import PageOrgCourse from '@/page/byl/org/course/model'
import PageOrgCourseList from '@/page/byl/org/course/list'
import PageOrgLivePlay from '@/page/byl/org/livePlay/model'
import PageOrgLivePlayList from '@/page/byl/org/livePlay/list'
import PageOrgBanner from '@/page/byl/org/banner/model'
import PageOrgBannerList from '@/page/byl/org/banner/list'
import PageMenu from '@/page/byl/org/orgmenu/model'
import PageMenuList from '@/page/byl/org/orgmenu/list'
import PageOrgRole from '@/page/byl/org/role/model'
import PageOrgRoleList from '@/page/byl/org/role/list'
import PageOrgRoleDistributeList from '@/page/byl/org/role/distribute'
import PageRole from '@/page/byl/org/orgrole/model'
import PageRoleList from '@/page/byl/org/orgrole/list'
import PageRoleDistributeList from '@/page/byl/org/orgrole/distribute'
import PageDictList from '@/page/byl/org/orgdict/list'
import PageDict from '@/page/byl/org/orgdict/model'
import PageUserList from '@/page/byl/org/user/list'
import PageOrgInfo from '@/page/byl/org/orginfo/list'
import PageOrgAppList from '@/page/byl/org/appmgt/list'
import PageOrgApp from '@/page/byl/org/appmgt/model'
/* 考试-考卷-考题-问卷--start */
import PageOrgExamPaper from '@/page/byl/org/examination_paper/model'
import PageOrgExamPaperList from '@/page/byl/org/examination_paper/list'
import PageOrgExamPaperScoreList from '@/page/byl/org/examination_paper/scoreList'
import PageOrgExamPaperScoreByTeacher from '@/page/byl/org/examination_paper/scoreByTeacher'
import PageOrgExamPaperAnswerList from '@/page/byl/org/examination_paper/answerList'
import PageOrgExamClassification_f from '@/page/byl/org/examination_paper/classification_f'
import PageOrgExamClassification_s from '@/page/byl/org/examination_paper/classification_s'
import PageOrgExamClassification_relate from '@/page/byl/org/examination_paper/classification_relate'

import PageOrgExamQuestionList from '@/page/byl/org/examination_question/list'
import PageOrgExamQ_ShortAnswer from '@/page/byl/org/examination_question/model_shortAnswer'
import PageOrgExamQ_Judgment from '@/page/byl/org/examination_question/model_judgment'
import PageOrgExamQ_Completion from '@/page/byl/org/examination_question/model_completion'
import PageOrgExamQ_Choice from '@/page/byl/org/examination_question/model_choice'
import PageOrgExamQ_MultipleChoice from '@/page/byl/org/examination_question/model_multipleChoice'

import PageOrgExamQClassification_f from '@/page/byl/org/examination_question/classification_f'
import PageOrgExamQClassification_s from '@/page/byl/org/examination_question/classification_s'
import PageOrgExamQClassification_relate from '@/page/byl/org/examination_question/classification_relate'

import PageOrgQuestionnaire from '@/page/byl/org/questionnaire/model'
import PageOrgQuestionnaireStat from '@/page/byl/org/questionnaire/statistics'
import PageOrgQuestionnaireList from '@/page/byl/org/questionnaire/list'
/* 考试-考卷-考题-问卷--end */
import PageOrgTeacher from '@/page/byl/org/teacher/model'
import PageOrgTeacherList from '@/page/byl/org/teacher/list'
import PageOrgEnroll from '@/page/byl/org/enroll/model'
import PageOrgEnrollList from '@/page/byl/org/enroll/list'
import PageOrgEnrollConfirm from '@/page/byl/org/enroll/confirm'
import PageOrgEnrollAudit from '@/page/byl/org/enroll/audit'
import PageOrgEnrollCheck from '@/page/byl/org/enroll/check'
import PageOrgCert from '@/page/byl/org/cert/model'
import PageOrgCertList from '@/page/byl/org/cert/list'
import PageOrgSendCert from '@/page/byl/org/cert/send'
import PageOrgCertRecord from '@/page/byl/org/cert/record'
import PageOrgPlan from '@/page/byl/org/plan/model'
import PageOrgPlanList from '@/page/byl/org/plan/list'
import PageOrgInformation from '@/page/byl/org/information/model'
import PageOrgInformationList from '@/page/byl/org/information/list'

/* 个人中心模块 */
import Center from '@/page/byl/uc/index'
import Record from '@/page/modules/uc/record'
import Fav from '@/page/modules/uc/fav'
import Examination from '@/page/modules/uc/examination'
import Enroll from '@/page/modules/uc/enroll'
import Certificate from '@/page/modules/uc/certificate'
import Message from '@/page/modules/uc/message'
import Set from '@/page/modules/uc/Set'
import Order from '@/page/modules/uc/Order'
import Invoice from '@/page/modules/uc/invoice'
import LearnRecord from '@/page/modules/uc/learnrecord'
/* 个人中心模块 */
import Test from '@/page/byl/test'
/* 平台模块 */
import PagePlatform from '@/page/byl/sys/index'
/* 平台模块 */

import Reload from '@/page/reload'

/* 前端页面路由模块 */
import ModulePay from '@/page/modules/pay/pay'
import ModuleWXPay from '@/page/modules/pay/wxPay'
import ModulePayResult from '@/page/modules/pay/result'

import ModuleEmailResult from '@/page/modules/email/result'

import ModuleCourseList from '@/page/modules/course/list'
import ModuleCourseDetail from '@/page/modules/course/detail'

import ModuleTeacherList from '@/page/modules/teacher/list'
import ModuleTeacherDetail from '@/page/modules/teacher/detail'

import ModuleExamAbout from '@/page/modules/exam/about'
import ModuleExamReady from '@/page/byl/exam/ready'
import ModuleExamStart from '@/page/byl/exam/start'
import ModuleExamAnalysis from '@/page/byl/exam/analysis'
import ModuleExamResult from '@/page/byl/exam/result'
import ModuleExamList from '@/page/modules/exam/list'

import ModuleLivePlayList from '@/page/modules/livePlay/list'
import ModuleLivePlayDetail from '@/page/modules/livePlay/detail'

//关于我们
import AboutUs from '@/page/byl/aboutUs/aboutUs'
const routes = [
  {
    path: '/byl/index',
    component: Index,
    children: [
      {
        path: '/byl/index',
        name: '首页',
        component: Home
      },
      {
        path: '/byl/characteristic',
        name: '平台特色',
        component: Characteristic
      },
      {
        path: '/byl/training',
        name: '企业内训',
        component: Training
      },
      {
        path: '/byl/web_education',
        name: '职称教育',
        component: Web_education
      },
      {
        path: '/byl/wxPay',
        name: '微信支付',
        component: ModuleWXPay
      },
      {
        path: '/byl/payResult/:type/:businessId/:res_url',
        name: '购买结果',
        component: ModulePayResult
      },
      {
        path: '/byl/emailConfirms',
        name: '邮箱激活',
        component: ModuleEmailResult
      },
      {
        path: '/byl/courseList',
        name: '课程列表',
        component: ModuleCourseList
      },
      {
        path: '/byl/courseDetail/:id',
        name: '课程详情',
        component: ModuleCourseDetail
      },
      {
        path: '/byl/coursePay/:id/:type/:businessId/:orgType/:result_url/:sign',
        name: '课程购买',
        component: ModulePay
      },

      {
        path: '/byl/examList',
        name: '考试列表',
        component: ModuleExamList
      },
      {
        path: '/byl/examPayAbout/:id',
        name: '考试购买简介',
        component: ModuleExamAbout
      },
      {
        path: '/byl/examPaperPay/:id/:type/:businessId/:orgType/:result_url/:sign',
        name: '考试购买',
        component: ModulePay
      },
      {
        path: '/byl/examReady/:id/:type',
        name: '开始考试',
        component: ModuleExamReady
      },
      {
        path: '/byl/examStart/:id/:examId',
        name: '考试页面',
        component: ModuleExamStart
      },
      {
        path: '/byl/examAnalysis/:id/:examId/:infoId',
        name: '考试分析',
        component: ModuleExamAnalysis
      },
      {
        path: '/byl/examResult/:examId',
        name: '考试结果',
        component: ModuleExamResult
      },
      {
        path: '/byl/livePlayList',
        name: '直播列表',
        component: ModuleLivePlayList
      },
      {
        path: '/byl/livePlayDetail/:id',
        name: '直播详情',
        component: ModuleLivePlayDetail
      },
      {
        path: '/byl/livePlayPay/:id/:type/:businessId/:orgType/:result_url/:sign',
        name: '直播购买',
        component: ModulePay
      },
      {
        path: '/byl/teacherList',
        name: '讲师列表',
        component: ModuleTeacherList
      },
      {
        path: '/byl/teacherDetail/:id',
        name: '讲师详情',
        component: ModuleTeacherDetail
      },
      {
        path: '/byl/uc/record',
        name: 'Center',
        component: Center,
        children: [
          {
            path: '/byl/uc/record',
            name: 'Record',
            component: Record
          },
          {
            path: '/byl/uc/fav',
            name: 'Fav',
            component: Fav
          },
          {
            path: '/byl/uc/examination',
            name: 'Examination',
            component: Examination
          },
          {
            path: '/byl/uc/enroll',
            name: 'Enroll',
            component: Enroll
          },
          {
            path: '/byl/uc/certificate',
            name: 'Certificate',
            component: Certificate
          },
          {
            path: '/byl/uc/message',
            name: 'Message',
            component: Message
          },
          {
            path: '/byl/uc/set',
            name: 'Set',
            component: Set
          },
          {
            path: '/byl/uc/order',
            name: 'Order',
            component: Order
          },
          {
            path: '/byl/uc/invoice',
            name: 'Invoice',
            component: Invoice
          },
          {
            path: '/byl/uc/lrecord',
            name: 'LearnRecord',
            component: LearnRecord
          }
        ]
      },
      {
        path: '/byl/aboutUs',
        name: '关于我们',
        component: AboutUs
      }
    ]
  }, {
    path: '/reload',
    component: Reload
  }, {
    path: '/byl/login',
    component: PageLogin
  }, {
    path: '/byl/orgreg',
    component: PageOrgReg
  }, {
    path: '/byl/findpwd',
    component: PageFindPwd
  }, {
    path: '/byl/resetpwd',
    component: PageResetPwd
  }, {
    path: '/org',
    component: PageOrg,
    redirect: '/org/entinfo',
    children: [
      {
        path: '/org/structure',
        name: '组织架构',
        component: PageOrgStructure
      },
      {
        path: '/org/reports',
        name: '报表管理',
        component: PageOrgReports
      },
      {
        path: '/org/externals',
        name: '外部系统',
        component: PageOrgExternals
      },
      {
        path: '/org/group',
        name: '小组管理',
        component: PageOrgGroup
      },
      {
        path: '/org/tag/:id',
        component: PageOrgTag
      },
      {
        path: '/org/tagList',
        name: '标签管理',
        component: PageOrgTagList,
        meta: {
          title: '标签管理',
          description: '标签管理'
        }
      },
      {
        path: '/org/resource/:id',
        component: PageOrgResource
      },
      {
        path: '/org/resourceList',
        name: '课件资源管理',
        component: PageOrgResourceList,
        meta: {
          title: '课件资源管理',
          description: '课件资源管理'
        }
      },
      {
        path: '/org/repo/:id',
        component: PageOrgRepo
      },
      {
        path: '/org/repoList',
        name: '知识库管理',
        component: PageOrgRepoList,
        meta: {
          title: '知识库管理',
          description: '知识库管理'
        }
      },
      {
        path: '/org/course/:id',
        name: '课程编辑',
        component: PageOrgCourse
      },
      {
        path: '/org/courseList',
        name: '课程管理',
        component: PageOrgCourseList
      },
      {
        path: '/org/livePlay/:id',
        name: '直播编辑',
        component: PageOrgLivePlay
      },
      {
        path: '/org/livePlayList',
        name: '直播管理',
        component: PageOrgLivePlayList
      },
      {
        path: '/org/questionnaire/:id',
        name: '问卷编辑',
        component: PageOrgQuestionnaire
      },
      {
        path: '/org/questionnaireStat/:id',
        name: '问卷统计',
        component: PageOrgQuestionnaireStat
      },
      {
        path: '/org/questionnaireList',
        name: '问卷管理',
        component: PageOrgQuestionnaireList
      },
      {
        path: '/org/examPaper/:id',
        name: '考卷编辑',
        component: PageOrgExamPaper
      },
      {
        path: '/org/examPaperList',
        name: '考卷管理',
        component: PageOrgExamPaperList
      },
      {
        path: '/org/examPaperScoreList/:id',
        name: '考卷成绩一览',
        component: PageOrgExamPaperScoreList
      },
      {
        path: '/org/examPaperScoreByTeacher/:examId/:paperId',
        name: '老师评分',
        component: PageOrgExamPaperScoreByTeacher
      },
      {
        path: '/org/examPaperAnswerList/:id',
        name: '考卷成绩回答一览',
        component: PageOrgExamPaperAnswerList
      },
      {
        path: '/org/examClassification_f/:path/:id',
        name: '大分类管理',
        component: PageOrgExamClassification_f
      },
      {
        path: '/org/examClassification_s/:path/:id',
        name: '小分类管理',
        component: PageOrgExamClassification_s
      },
      {
        path: '/org/examClassification_relate/:path/:id/:fValue/:fLabel',
        name: '分类关联',
        component: PageOrgExamClassification_relate
      },
      {
        path: '/org/examQuestionList',
        name: '考题管理',
        component: PageOrgExamQuestionList
      },
      {
        path: '/org/examQuestionShortAnswer/:id',
        name: '简答题编辑',
        component: PageOrgExamQ_ShortAnswer
      },
      {
        path: '/org/examQuestionCompletion/:id',
        name: '填空题编辑',
        component: PageOrgExamQ_Completion
      },
      {
        path: '/org/examQuestionChoice/:id',
        name: '选择题编辑',
        component: PageOrgExamQ_Choice
      },
      {
        path: '/org/examQuestionJudgment/:id',
        name: '判断题编辑',
        component: PageOrgExamQ_Judgment
      },
      {
        path: '/org/examQuestionMultipleChoice/:id',
        name: '多选题编辑',
        component: PageOrgExamQ_MultipleChoice
      },
      {
        path: '/org/examQClassification_f/:path/:id',
        name: '考题大分类管理',
        component: PageOrgExamQClassification_f
      },
      {
        path: '/org/examQClassification_s/:path/:id',
        name: '考题小分类管理',
        component: PageOrgExamQClassification_s
      },
      {
        path: '/org/examQClassification_relate/:path/:id/:fValue/:fLabel',
        name: '考题分类关联',
        component: PageOrgExamQClassification_relate
      },
      {
        name: '消息管理',
        path: '/org/msgList',
        component: PageOrgMsgList
      },
      {
        name: '消息发送',
        path: '/org/msg',
        component: PageOrgMsg
      },
      {
        name: '培训计划管理',
        path: '/org/planList',
        component: PageOrgPlanList
      },
      {
        name: '培训计划管理(编辑)',
        path: '/org/plan/:id',
        component: PageOrgPlan
      },
      {
        name: '报名管理',
        path: '/org/enrollList',
        component: PageOrgEnrollList
      },
      {
        name: '报名管理(编辑)',
        path: '/org/enroll/:id',
        component: PageOrgEnroll
      },
      {
        name: '报名人员列表',
        path: '/org/enrollConfirm/:id',
        component: PageOrgEnrollConfirm
      },
      {
        name: '报名审核',
        path: '/org/enrollAudit/:id',
        component: PageOrgEnrollAudit
      },
      {
        name: '报名签到',
        path: '/org/enrollCheck/:id',
        component: PageOrgEnrollCheck
      },
      {
        name: '证书管理',
        path: '/org/certList',
        component: PageOrgCertList
      },
      {
        name: '证书管理(编辑)',
        path: '/org/cert/:id',
        component: PageOrgCert
      },
      {
        name: '发证书',
        path: '/org/sendcert',
        component: PageOrgSendCert
      },
      {
        name: '发证记录',
        path: '/org/certrecord',
        component: PageOrgCertRecord
      },
      {
        name: '讲师管理',
        path: '/org/teacherList',
        component: PageOrgTeacherList
      },
      {
        name: '讲师管理(编辑)',
        path: '/org/teacher/:id',
        component: PageOrgTeacher
      },
      {
        name: '公告管理',
        path: '/org/informationList',
        component: PageOrgInformationList
      },
      {
        name: '公告管理(编辑)',
        path: '/org/information/:id',
        component: PageOrgInformation
      },
      {
        path: '/org/bannerList',
        name: '推荐列表',
        component: PageOrgBannerList
      },
      {
        path: '/org/banner/:id',
        name: '推荐详情',
        component: PageOrgBanner
      },
      {
        path: '/org/menuList',
        name: '菜单管理',
        component: PageMenuList
      },
      {
        path: '/org/menu/:id/:parentId',
        name: '菜单管理(编辑)',
        component: PageMenu
      },
      {
        path: '/org/orgroleList',
        name: '机构角色管理',
        component: PageOrgRoleList
      },
      {
        path: '/org/orgrole/:id',
        name: '机构角色管理(编辑)',
        component: PageOrgRole
      },
      {
        path: '/org/orgrole/distribute/:id',
        name: '机构角色分配管理',
        component: PageOrgRoleDistributeList
      },
      {
        path: '/org/roleList',
        name: '角色管理',
        component: PageRoleList
      },
      {
        path: '/org/role/:id',
        name: '角色管理(编辑)',
        component: PageRole
      },
      {
        path: '/org/role/distribute/:id',
        name: '角色分配管理',
        component: PageRoleDistributeList
      },
      {
        path: '/org/dictList',
        name: '字典管理',
        component: PageDictList
      },
      {
        path: '/org/dict/:id',
        name: '字典管理(编辑)',
        component: PageDict
      },
      {
        path: '/org/entinfo',
        name: '机构信息管理',
        component: PageOrgInfo
      },
      {
        path: '/org/userList',
        name: '用户管理',
        component: PageUserList
      },
      {
        path: '/org/appmgtList',
        name: 'APP管理',
        component: PageOrgAppList
      },
      {
        path: '/org/appmgt/:id',
        name: 'APP版本编辑',
        component: PageOrgApp
      }
    ]
  }, {
    path: '/Test',
    name: 'Test',
    component: Test
  },
  {
    path: '/platform',
    component: PagePlatform,
    redirect: '/platform/dictList',
    children: [
      {
        path: '/platform/dictList',
        name: 'dictList',
        component: PageDictList
      },
      {
        path: '/platform/dict/:id',
        name: 'dict',
        component: PageDict
      },
      {
        path: '/platform/menuList',
        name: 'menuList',
        component: PageMenuList
      },
      {
        path: '/platform/menu/:id',
        name: 'menu',
        component: PageMenu
      },
      {
        path: '/platform/roleList',
        name: 'roleList',
        component: PageRoleList
      },
      {
        path: '/platform/role/:id',
        name: 'role',
        component: PageRole
      }
    ]
  }, {
    path: '/',
    redirect: '/byl/index'
  }
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/router-byl.js